import { connect } from "react-redux";
import IngresoActions from "../../../stores/ingreso/Actions";
import CustomInput from "../../../components/CustomForm/CustomInput";
import CustomSelect from "../../../components/CustomForm/CustomSelect";
import {
  FormWrapper,
  Form,
  FormGroup,
} from "../../../components/CustomForm/FormStyles";
import useEmpresa from "../../../hooks/useEmpresa";
import {
  CONTRATO_OXIGENO,
  CODIGO_CONTRATO_OXIGENO,
  COBERTURA_VALIDACION,
  MAX_LENGTH_LITROS
} from "../utils/IngresoConstant";
import Text from "../../../components/Common/Text";
import CustomButton from "../../../components/CustomButton/CustomButton";
import CustomSeparator from "../../../components/Common/CustomSeparator";
import Colors from "../../../themes/Colors";
import { Section } from "../../../components/CustomLayout/CustomLayoutStyles";
import { IngresoFormButtonsContainer } from "../styles/IngresoStyles";
import { IngresoFormButtonsLeft } from "../styles/IngresoStyles";
import { cleanCurrency } from "../../../utils/CurrencyUtil";
import { isEmptyValue } from "../../../utils/StringUtil";

const CalculadoraOxigeno = (props) => {
  const { formCierreCuentasData, authUserData } = props;

  const { prestador } = authUserData;

  const empresa = useEmpresa();

  const onStateChange =
    (key, format = null) =>
    (value) => {
      if (key === "contratoOxigeno") {
        props.formCierreCuentas({
          ...formCierreCuentasData,
          contratoOxigeno: value,
          cantidadOxigeno: "",
          montoOxigeno: "",
        });
        return;
      }

      props.formCierreCuentas({
        ...formCierreCuentasData,
        [key]: format ? format(value) : value,
      });
    };

  const realizarCalculoOxigeno = () => {
    const { contratoOxigeno, cantidadOxigeno, montoOxigeno } =
      formCierreCuentasData;

    if (
      Number(contratoOxigeno) === Number(CODIGO_CONTRATO_OXIGENO.LITRO) &&
      (isEmptyValue(cantidadOxigeno) || Number(cantidadOxigeno) === 0)
    ) {
      props.formCierreCuentas({
        ...formCierreCuentasData,
        alertConfig: {
          type: "info",
          title: "¡Hola!",
          message: "Favor ingresar la cantidad de litros",
          onConfirm: () => {
            props.formCierreCuentas({
              ...formCierreCuentasData,
              showAlert: false,
              showRequired: true,
            });
          },
        },
        showAlert: true,
        showRequired: true,
      });
      return;
    }

    if (
      Number(contratoOxigeno) === Number(CODIGO_CONTRATO_OXIGENO.MONTO) &&
      (isEmptyValue(montoOxigeno) || Number(montoOxigeno) === 0)
    ) {
      props.formCierreCuentas({
        ...formCierreCuentasData,
        alertConfig: {
          type: "info",
          title: "¡Hola!",
          message: "Favor ingresar el monto",
          onConfirm: () => {
            props.formCierreCuentas({
              ...formCierreCuentasData,
              showAlert: false,
              showRequired: true,
            });
          },
        },
        showAlert: true,
        showRequired: true,
      });
      return;
    }

    props.calcularOxigeno({ formCierreCuentasData });
  };

  const agregarCoberturaOxigeno = () => {
    const { tipoPss, codigoPss, montoOxigeno } = formCierreCuentasData;

    if (
      isEmptyValue(tipoPss) ||
      isEmptyValue(codigoPss) ||
      Number(codigoPss) === 0
    ) {
      props.validarProcedimientoCierreCuentas({
        formCierreCuentasData: {
          ...formCierreCuentasData,
          tipoPss: prestador?.tipoPss,
          codigoPss: prestador?.codigo,
          montoReclamado: montoOxigeno,
        },
        formHandler: props.formCierreCuentas,
        codigoProcedimiento: COBERTURA_VALIDACION.OXIGENO,
        frecuencia: 1,
        validacionOxigeno: true,
      });
      return;
    }

    props.validarProcedimientoCierreCuentas({
      formCierreCuentasData: {
        ...formCierreCuentasData,
        montoReclamado: montoOxigeno,
      },
      formHandler: props.formCierreCuentas,
      codigoProcedimiento: COBERTURA_VALIDACION.OXIGENO,
      frecuencia: 1,
      validacionOxigeno: true,
    });
  };

  const limpiarCalculoOxigeno = () => {
    props.formCierreCuentas({
      ...formCierreCuentasData,
      cantidadOxigeno: "",
      montoOxigeno: "",
      bloquearCamposOxigeno: false,
    });
  };

  const cerrarCalculadoraOxigeno = () => {
    props.formCierreCuentas({
      ...formCierreCuentasData,
      showModalCalculadoraOxigeno: false,
      cantidadOxigeno: "",
      montoOxigeno: "",
      bloquearCamposOxigeno: false,
    });
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      realizarCalculoOxigeno();
    }
  };

  return (
    <div align="center">
      <Text size="24px" isTittle={true} weight={"bold"} textAlign="center">
        {"Calculadora de cobertura de oxigeno"}
      </Text>

      <FormWrapper borderColor={empresa?.COLOR_PRINCIPAL}>
        <Form>
          <FormGroup>
            <CustomInput
              type={"text"}
              width={"auto"}
              placeholder={"Prestador"}
              label={"Prestador"}
              value={formCierreCuentasData?.nombrePss || prestador?.nombre}
              disabled={true}
            />
          </FormGroup>
          <FormGroup>
            <CustomInput
              type={"text"}
              width={"auto"}
              placeholder={"Tarifa contratada"}
              label={"Tarifa contratada"}
              value={formCierreCuentasData?.tarifaOxigeno}
              disabled={true}
            />
          </FormGroup>
          <FormGroup />
          <FormGroup>
            <CustomSelect
              options={CONTRATO_OXIGENO}
              showDefaultOption={true}
              label={"Contrato Oxigeno"}
              value={formCierreCuentasData?.contratoOxigeno}
              onChange={onStateChange("contratoOxigeno")}
              required={true}
              showRequired={formCierreCuentasData?.showRequired}
              disabled={false}
            />
          </FormGroup>
          <FormGroup>
            <CustomInput
              type={"text"}
              width={"auto"}
              placeholder={"Cantidad total de litros"}
              label={"Cantidad total de litros"}
              value={formCierreCuentasData?.cantidadOxigeno}
              onChange={onStateChange("cantidadOxigeno", cleanCurrency)}
              onBlur={realizarCalculoOxigeno}
              handleKeyPress={handleKeyPress}
              disabled={
                formCierreCuentasData?.bloquearCamposOxigeno ||
                Number(formCierreCuentasData?.contratoOxigeno) ===
                  Number(CODIGO_CONTRATO_OXIGENO.MONTO)
              }
              maxLength={MAX_LENGTH_LITROS}
            />
          </FormGroup>
          <FormGroup>
            <CustomInput
              type={"text"}
              width={"auto"}
              placeholder={"Monto Reclamado"}
              label={"Monto Reclamado"}
              value={formCierreCuentasData?.montoOxigeno}
              onChange={onStateChange("montoOxigeno", cleanCurrency)}
              onBlur={realizarCalculoOxigeno}
              handleKeyPress={handleKeyPress}
              disabled={
                formCierreCuentasData?.bloquearCamposOxigeno ||
                Number(formCierreCuentasData?.contratoOxigeno) ===
                  Number(CODIGO_CONTRATO_OXIGENO.LITRO)
              }
            />
          </FormGroup>
        </Form>

              <Section align={"center"} padding={"10px"}>
        <IngresoFormButtonsContainer>
          <IngresoFormButtonsLeft>
            <CustomButton
              label={"Limpiar Cálculo"}
              onClick={limpiarCalculoOxigeno}
              disabled={false}
              weight={"bold"}
              hoverColor={empresa?.COLOR_PRINCIPAL}
              bgColor={Colors.white}
              textColor={empresa?.COLOR_PRINCIPAL}
              border={`1px solid ${empresa?.COLOR_PRINCIPAL}`}
            />
            <CustomSeparator width={"10px"} />
            <CustomButton
              label={"Agregar Cobertura"}
              onClick={agregarCoberturaOxigeno}
              bgColor={empresa?.COLOR_SECUNDARIO}
              hoverColor={empresa?.COLOR_PRINCIPAL}
              weight={"bold"}
              disabled={!formCierreCuentasData?.bloquearCamposOxigeno}
            />
            <CustomSeparator width={"10px"} />
            <CustomButton
              label={"Cancelar"}
              onClick={cerrarCalculadoraOxigeno}
              disabled={false}
              weight={"bold"}
              hoverColor={Colors.huMyHealth}
              bgColor={Colors.white}
              textColor={Colors.huMyHealth}
              border={`1px solid ${Colors.huMyHealth}`}
            />
          </IngresoFormButtonsLeft>
        </IngresoFormButtonsContainer>
      </Section>
      </FormWrapper>


    </div>
  );
};

const mapStateToProps = (state) => ({
  authUserData: state.auth.authUserData,
  authUserLoading: state.auth.authUserLoading,
  authUserError: state.auth.authUserError,

  formCierreCuentasData: state.ingreso.formCierreCuentasData,
  formCierreCuentasLoading: state.ingreso.formCierreCuentasLoading,
});

const mapDispatchToProps = {
  formCierreCuentas: IngresoActions.formCierreCuentas,
  calcularOxigeno: IngresoActions.calcularOxigeno,
  validarProcedimientoCierreCuentas:
    IngresoActions.validarProcedimientoCierreCuentas,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(CalculadoraOxigeno);
